import { AccessCodeService, OrganizationsService } from '@shared/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutCollapseSideNavAction } from '@shared/store/actions/layout-actions';
import {
	getLayoutEnableAdminOptions,
	getLayoutIsAdminMenu,
	getLayoutScopeId,
	getOrganizationAll,
	getOrganizationById,
	getSessionClaimsAdmin
} from '@shared/store/selectors';
import { select, Store } from '@ngrx/store';
import * as moment from 'moment';
import { EMPTY, interval, Subscription } from 'rxjs';
import { map, mergeMap, switchMap, take, tap } from 'rxjs/operators';
import { AngularFireAuth } from '@angular/fire/compat/auth';

@Component({
	selector: 'spaq-layout-account-header',
	templateUrl: './layout-account-header.component.html',
	styleUrls: ['./layout-account-header.component.scss']
})
export class LayoutAccountHeaderComponent {
	adminOrganizationList$ = this.organizationService.getAll(true);
	adminSelectedOrganization$ = this.organizationService.selectedOrganization$;
	adminSelectedGroup$ = this.organizationService.selectedGroup$;
	adminSelectedOrganizationGroups$ = this.organizationService.getSelectedOrganizationGroups(true);

	isAdminMenu$ = this.store.pipe(select(getLayoutIsAdminMenu));
	scopeId$ = this.store.pipe(select(getLayoutScopeId));
	organization$ = this.scopeId$.pipe(
		switchMap(id =>
			this.store.pipe(
				select(getOrganizationById, id),
				map(x => (x && x.organizationName) || 'Public')
			)
		)
	);
	organizationList$ = this.store.pipe(
		select(getOrganizationAll),
		map(x => [...x])
	);
	enableAdminOptions$ = this.store.pipe(select(getLayoutEnableAdminOptions));
	states = {
		error: 0,
		success: 0,
		pending: 0
	};
	status = {
		idle: false,
		payment: false,
		vault: false,
		contract: false,
		pdf: false,
		preauth: false
	};
	subscription: Subscription;

	constructor(
		public organizationService: OrganizationsService,
		private accessCodeService: AccessCodeService,
		private afAuth: AngularFireAuth,
		private store: Store<any>
	) {}

	ngOnDestroy() {}
	onOrganizationClick(organization: any) {
		if (!organization.organizationCode) {
			localStorage.removeItem('selectedOrganization');
			return this.afAuth.user
				.pipe(
					take(1),
					mergeMap(u => this.accessCodeService.resetForOrganizationChange(u.uid)),
					take(1)
				)
				.subscribe(() => {
					location.reload();
				});
		}
		localStorage.setItem('selectedOrganization', organization.organizationCode);
		return this.afAuth.user
			.pipe(
				take(1),
				mergeMap(u => this.accessCodeService.resetForOrganizationChange(u.uid)),
				take(1)
			)
			.subscribe(() => {
				location.reload();
			});
	}
	ngOnInit() {}

	collapse() {
		this.store.dispatch(new LayoutCollapseSideNavAction(null, Date.now()));
	}
}
